import React,{ useState, useEffect } from 'react';
import {AiOutlineUserAdd} from 'react-icons/ai';
import EditIconButton from "../../components/IconButtons/EditIconButton";
import DeleteIconButton from "../../components/IconButtons/DeleteIconButton";
import { TooltipComponent } from '@syncfusion/ej2-react-popups';
import { useStateContext } from '../../contexts/ContextProvider';
import {useRegistroMutations} from '../../hooks';
import {getRegistroPlanes} from "../../services/RegistroPlanes";
import {formatDate} from '../../formatters/date';
import {getPlanes} from "../../services/Planes";
import SeleccionaFecha from '../../components/DatePicker/SeleccionaFecha';

import DataTable from 'react-data-table-component';
import { NuevaRegistro } from '../../components';
import { toast } from 'react-hot-toast';


const NavButton = ({ title, customFunc, icon, color, texto }) => (
  <TooltipComponent content={title} position="BottomCenter">
    <button
      type="button"
      onClick={() => customFunc()}
      style={{ backgroundColor: color}}
      className="relative text-xl  text-white rounded-lg p-3 hover:bg-light-gray"
    >
      <div className="flex flex-row justify-between items-center">
        <div>{icon}</div>
        <div><p className="text-xs ">{texto}</p></div>
      </div>
    
    </button>

  </TooltipComponent>
);

const RegistroClientes = () => {
  const { currentColor, handleClick, isClicked } = useStateContext();
  const {removeRegistro} = useRegistroMutations();
  const [selectedDate, setSelectedDate] = useState(getFirstDayOfMonth('Inicio')); // Fecha inicial
  const [selectedDateEnd, setSelectedDateEnd] = useState(getFirstDayOfMonth('Fin')); // Fecha inicial
  const [estado, setEstado] = useState('ALL');
  const [tipoSolicitud, setTipoSolicitud] = useState('ALL');
  const [planesData, setPlanesData] = useState([]);
  const [archivosData, setArchivosData] = useState([]);
  const [laSucursal, setLaSucursal] = useState("");

  useEffect(()=>{
    const fetchData = async () => {
      const misPlanes = await getPlanes();
      setPlanesData(misPlanes);
    };
    fetchData();
  },[]);

  useEffect(()=>{
    const fetchData = async () => {

      const docuData = await getRegistroPlanes(selectedDate.toISOString(),selectedDateEnd.toISOString(),tipoSolicitud,estado );
      setArchivosData(docuData);

    };
    fetchData();
    // rutCliPro,razonSocial
  },[selectedDate,selectedDateEnd,tipoSolicitud,estado]);


  function getFirstDayOfMonth(Como) {
    const today = new Date();
    const firstDay = new Date(today.getFullYear(), today.getMonth(), 1);
    if(Como === 'Inicio') return firstDay;
    if(Como === 'Fin') return today;
    if(Como === 'Nada') return null;
  };

  const handleDateChange = (date) => {
    setSelectedDate(date);
  };

  const handleDateChangeEnd = (date) => {
    setSelectedDateEnd(date);
  };

  const handleChangeEstado = (e) =>{
    setEstado( e.target.value );
  }

  const handleChangeTipoSolicitud = (e) =>{
    setTipoSolicitud( e.target.value );
  }

  const handleEdit = (sucursalData) => {
    setLaSucursal(sucursalData);
    handleClick('nuevasolicitud');
  };

  const handleEliminar = async (row) => {
    //console.log('voy a eliminar ' + row._id);
    if(row.estado ==="Pendiente"){
      setArchivosData((prevData) => prevData.filter((item) => item._id !== row._id));
      await removeRegistro.mutateAsync(row._id);
      setArchivosData((prevData) =>(prevData));
  
    } else {
      toast.error('Solicitud no puede ser eliminada.');
      return;
    }
  };

  const handleRefreshDataTable = (opcion) => {
    // console.log(" OPCION LLEGO -> " + opcion);
    if (opcion==="REFRESH"){
      const fetchData = async () => {
        const docuData = await getRegistroPlanes(selectedDate.toISOString(),selectedDateEnd.toISOString(),tipoSolicitud,estado);
        setArchivosData(docuData);  
      };
      fetchData();
    }
  };

  const customStyles = {
    table: {
      style: {
        backgroundColor: 'white',
      },
    },
    headRow: {
      style: {
        backgroundColor: 'white',
        fontSize: 12,
        borderRadius: 8,
        fontWeight: '400',
        color: '#AEB2D7',
        borderWidth: 0,
        textAlign: 'center',
        headerStyles:{
          backgroundColor: '#F2F5FE',
          fontWeight: 'bold',
          color: '#2F336A',
        },
      },
    },
    rows: {
      style: {
        minHeight: '50px',
        margin: '4px 0px',
        backgroundColor: 'white',
        borderRadius: 8,
        fontSize: 10,
        rowStyles:{
          borderBottom: 1,
        }
      },
    },
  };

  const columns = [
    {
      name: '',
      width: '40px',
      cell: (row) => ( <EditIconButton onClick={() => handleEdit(row)} /> )
    },
    {
      name: '',
      width: '40px',
      cell: (row) => ( <DeleteIconButton onClick={() => handleEliminar(row)} /> )
    },
    {
      name: 'N°',
      width: '80px',
      selector: row => row.numeroRegistro,
      sortable: true
    },
    {
      name: 'Fecha',
      selector: row => formatDate(row.fechaCreacion),
      sortable: true
    },
    {
      name: 'Rut',
      selector: row => row.rutCliPro,
      sortable: true
    },
    {
      name: 'Cliente',
      selector: row => row.razonSocial,
      sortable: true
    },
    {
      name: 'Dirección',
      selector: row => row.direccion,
      sortable: true
    },
    {
        name: 'Recolector',
        width: '180px',
        selector: row => row.nombreRecolector,
        sortable: true,
        cell: (row) => {
          let bgColor = '';
          switch (row.nombreRecolector) {
            case 'Sin recolector':
              bgColor = 'bg-red-100 text-red-700';
              break;

            default:
              bgColor = 'bg-green-100 text-green-700';
          }
          return (
            <div className={`text-xs px-2 py-1 rounded-full text-center ${bgColor}`}>
              {row.nombreRecolector}
            </div>
          );
        }
      },
        {
        name: 'Drop Off',
        width: '180px',
        selector: row => row.nombrePunto,
        sortable: true,
        cell: (row) => {
          let bgColor = '';
          switch (row.nombrePunto) {
            case 'Sin punto asignado':
              bgColor = 'bg-red-100 text-red-700';
              break;
            default:
              bgColor = 'bg-green-100 text-green-700';
          }
          return (
            <div className={`text-xs px-2 py-1 rounded-full text-center ${bgColor}`}>
              {row.nombrePunto}
            </div>
          );
        }
    },
    {
      name: 'Plan',
      selector: row => row.nombrePlan,
      sortable: true
    },
    {
      name: 'Valor',
      selector: row => row.valor,
      sortable: true
    },
    {
        name: 'Estado',
        width: '120px',
        selector: row => row.estado,
        sortable: true,
        cell: (row) => {
          let bgColor = '';
          switch (row.estado) {
            case 'Activo':
              bgColor = 'bg-green-100 text-green-700';
              break;
            case 'Pendiente':
              bgColor = 'bg-yellow-100 text-yellow-700';
              break;
            case 'Eliminado':
              bgColor = 'bg-red-100 text-red-700';
              break;
            case 'Bloqueado':
              bgColor = 'bg-blue-100 text-blue-700';
              break;
            default:
              bgColor = 'bg-gray-100 text-gray-700';
          }
          return (
            <div className={`text-xs px-2 py-1 rounded-full text-center ${bgColor}`}>
              {row.estado}
            </div>
          );
        }
      }

  ];

  return (

<>

    <div className="m-2 md:m-10 mt-16 p-2 md:p-10 bg-gray-200 rounded-3xl">

      {isClicked.nuevasolicitud && (<NuevaRegistro vecinoData={laSucursal} onChangeVecino={handleRefreshDataTable}/>)}

      <div className="bg-white p-6 rounded-lg shadow-lg items-end mt-4">
      
      <div className="flex justify-start items-center p-2 md:ml-6 md:mr-6 relative top-1">
          <div className="grid grid-cols-2 md:grid-cols-5 gap-4 mt-2 justify-between" >
              <div className="flex flex-col">
                <label className="text-xs font-semibold mb-1">Desde</label>
                  <SeleccionaFecha
                    selectedDate={selectedDate}
                    handleDateChange={handleDateChange}
                  />
              </div>  
              <div className="flex flex-col mr-2">
                <label className="text-xs font-semibold mb-1">Hasta</label>
                  <SeleccionaFecha
                    selectedDate={selectedDateEnd}
                    handleDateChange={handleDateChangeEnd}
                  />
              </div>  
              <div className="flex flex-col">
                  <label className="text-xs font-semibold mb-1">Plan</label>
                  <select className="text-xs border border-gray-300 p-2 rounded" name="tipoSolicitud" value= {tipoSolicitud} onChange={handleChangeTipoSolicitud}>   
                    <option value="ALL">Todos</option>
                    {planesData?.map((item, index) => (
                      <option  key={item._id} value={item._id}>{item.nombrePlan}</option>
                    ))}  
                    </select> 

              </div> 
              <div className="flex flex-col">
                  <label className="text-xs font-semibold mb-1">Estado</label>
                  <select className="text-xs border border-gray-300 p-2 rounded" name="estado" value= {estado} required onChange={handleChangeEstado}>   
                  <option value="ALL">Todos</option>
                  <option value="Activo">Activo</option>
                  <option value="Pendiente">Pendiente</option>
                  <option value="Bloqueado">Bloqueado</option>  
                  <option value="Eliminado">Eliminado</option>      
                  </select>
              </div>  
              <div className="flex flex-col justify-end">
                <NavButton title="Registrar Cliente" customFunc={() => { setLaSucursal(''); handleClick('nuevasolicitud')} } color={currentColor} icon={<AiOutlineUserAdd />} texto={' Registro'} />
            </div>
          </div>

        </div>
      </div>

      <div className="bg-white p-6 rounded-lg shadow-lg items-end mt-4">   
        <div className="grid grid-cols-1 md:grid-cols-1 gap-4" >
            <div className="flex flex-col">
              <DataTable
                columns={columns}
                data={archivosData}
                highlightOnHover
                pagination={true}
                striped
                className="border border-gray-300 rounded-lg shadow-sm"
                noHeader={true}
                selectableRowsHighlight
                customStyles={customStyles}
                noDataComponent={'No hay Clientes creados'}
              />
            </div>
        </div>
      </div>

    </div>
    </>
  );
};

export default RegistroClientes;